export const isProd = () =>
    location.hostname === "app.pitchlane.io" ||
    location.hostname === "app.pitchlane.com" ||
    location.hostname === "dashboard.pitchlane.com" ||
    (location.hostname.endsWith("onrender.com") && location.hostname.startsWith("prod-")) ||
    /^.*\.rackpl-.*-prod-.*\.pitchlane\.com$/.test(location.hostname) ||
    /^.*-prod-preview\.rackpl-.*\.pitchlane\.com$/.test(location.hostname)
export const isStaging = () => location.hostname === "app.staging.pitchlane.io"
